import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import About from "./Pages/About";
import Team from "./Pages/Team";
import Offers from "./Pages/Offers";
import Values from "./Pages/Values";
import Infrastructure from "./Pages/Infrastructure";
import Services from "./Pages/Services";
import Product from "./Pages/Product";
import Contact from "./Pages/Contact";
import Footer from "./Pages/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function App() {
    return (
        <div>
            <Navbar />
            <Hero />
            <About />
            <Team />
            <Offers />
            <Values />
            <Infrastructure />
            <Services />
            <Product />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;
